import { render, staticRenderFns } from "./UserPrivacy.vue?vue&type=template&id=5bc60d02&scoped=true"
import script from "./UserPrivacy.vue?vue&type=script&lang=js"
export * from "./UserPrivacy.vue?vue&type=script&lang=js"
import style0 from "./UserPrivacy.vue?vue&type=style&index=0&id=5bc60d02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc60d02",
  null
  
)

export default component.exports